import {
  getLegacyRefreshToken,
  refreshSession,
  RefreshSessionResult,
} from "../api";

// Update the refreshToken, but ensure only 1 request is made at a time.
export const updateRefreshToken = (() => {
  let ongoingRefreshTokenPromise = null;
  return (): Promise<RefreshSessionResult> => {
    if (ongoingRefreshTokenPromise === null) {
      ongoingRefreshTokenPromise = refreshSession({
        refreshToken: getLegacyRefreshToken(),
      }).then((r) => {
        ongoingRefreshTokenPromise = null;
        return r;
      });
    }
    return ongoingRefreshTokenPromise;
  };
})();
